import { Column } from '@app/modules/table/classes/column.class';
import { CellDisplay } from '@app/modules/table/enums/cell-display.enum';

export class IpAddressColumn extends Column {
    title = 'payroll.setup.padAgreementLogs.ipAddress';
    type = CellDisplay.string;
    property = 'ipAddress';
    displayWidth = 20;
}
